import { GraphQLResult } from "@aws-amplify/api-graphql";
import { API, graphqlOperation } from "aws-amplify";
import { createScenario, deleteScenario } from "graphql/mutations";
import { listScenarioSortBySortIndex } from "graphql/queries";
import {
  CreateScenarioInput,
  DeleteScenarioInput,
  ListScenarioSortBySortIndexQuery,
  ModelSortDirection,
  Scenario,
} from "types/graphqlapi";

/**
 * 同一案件のインタビューフローリストを取得
 * @param subjectId
 * @returns
 */
export const fetchScenarioBysubjectIdQuery = async (subjectId: string) => {
  const result = (await API.graphql(
    graphqlOperation(listScenarioSortBySortIndex, {
      subject_id: subjectId,
      sortDirection: ModelSortDirection.ASC,
      limit: 1000,
    })
  )) as {
    data: ListScenarioSortBySortIndexQuery;
  };

  const list = result.data?.listScenarioSortBySortIndex?.items as Scenario[];

  return list;
};

/**
 * 新規作成
 * @param
 * @returns 作成されたデータ
 */
export const createScenarioMutation = async (
  createScenarioInput: CreateScenarioInput
) => {
  const result = (await API.graphql(
    graphqlOperation(createScenario, {
      input: createScenarioInput,
    })
  )) as GraphQLResult<{ created: Scenario }>;

  return result;
};

/**
 * 特定のリソースデータ削除
 * @param
 * @returns 削除されたデータ
 */
export const deleteScenarioMutation = async (
  deleteScenarioInput: DeleteScenarioInput
) => {
  const result = (await API.graphql(
    graphqlOperation(deleteScenario, {
      input: deleteScenarioInput,
    })
  )) as GraphQLResult<{ deleted: Scenario }>;

  return result;
};
